import { render, staticRenderFns } from "./DialogConfirmBeginBalance.vue?vue&type=template&id=fb0da0de"
import script from "./DialogConfirmBeginBalance.vue?vue&type=script&lang=js"
export * from "./DialogConfirmBeginBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports